// Svelte action: переносит узел в указанный target (по умолчанию document.body)
// сразу при mount'е и убирает при unmount'е. Полезно для popup-элементов
// (dropdown / popover), которые клипаются overflow-родителями.
export function portal(node, target = "body") {
    function update(t) {
        const el = typeof t === "string" ? document.querySelector(t) : t;
        if (el)
            el.appendChild(node);
    }
    update(target);
    return {
        update,
        destroy() {
            if (node.parentNode)
                node.parentNode.removeChild(node);
        },
    };
}
